module.exports = __webpack_public_path__ + "static/media/QuizzAppSummary.b2c318a1.PNG";